import { render, staticRenderFns } from "./NeTreeForTask.vue?vue&type=template&id=2b1a3d34&"
import script from "./NeTreeForTask.vue?vue&type=script&lang=js&"
export * from "./NeTreeForTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports